import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { history } from '../helpers/history';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Title from './../components/Complements/Title';
import StepperQuestions from '../components/Questions/StepperQuestions'
import formValidation from "../helpers/formValidation"
import { getQuestions } from "../actions/questions";
import { createQuestionsByUser, findQuestionsByUser } from "../actions/userquestions";
import { responseQuestion } from "../actions/loginUser";
import { feathersCreateData } from '../services';
import DialogOTP from '../components/Complements/DialogOTP';
import { sendLogs } from '../functions/function-logs';
import { changeStatusUser } from './../actions/codes'
import { sendEmail } from "./../actions/sendemail";
import { validateIp } from '../functions/store';
import { encrypt } from './../functions/mobile';
import { filterArrayEqual } from '../functions/arrays';
import Footer from '../components/Complements/Footer';
import { IconButton } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';

const QuestionsContainer = props => {

    const { handleOpenSnack, getDeviceData, updateIpDevice, devices, parameters, user } = props
    const [dataQuestions, setDataQuestions] = useState([])
    const [dataQuestionsSelected, setDataQuestionsSelected] = useState([])
    const [question, setQuestion] = useState(0)
    const [answer, setAnswer] = useState("")
    const [type, setType] = useState("text")
    const [activeStep, setActiveStep] = useState(0)
    const [loading, setLoading] = useState(false)
    const [flagHaveQuestionsUser, setFlagHaveQuestionsUser] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [openDialogOTP, setOpenDialogOTP] = useState(false);
    const [initialTime, setInitialTime] = useState(Date.now());

    const mount = () => {
        const unmount = () => {

            if ((user.flagResetPassword === 1) && (user.flagResetSecurityQuestions === 1)) {
                handleOpenSnack("Bienvenido a la plataforma Gañansol - Movil. Por favor registre sus preguntas de seguridad y modifique su contraseña por temas de seguridad.", "info")
            }
            handleGetDataQuetions()
        }
        return unmount()
    }

    useEffect(mount, [])

    const handleGetDataQuetions = () => {

        setLoading(true)

        getQuestions().payload.then(
            response => {
                //console.log(response)
                const { data } = response;
                setDataQuestions(data)
                handleGetDataByIdentificationUser(data)
            }
        ).catch(
            error => {
                //console.log(error)
                handleOpenSnack("Ha ocurrido un error al obtener las preguntas. Por favor vuelva a intentar.", "error")
                setLoading(false)
            }
        )
    }

    const handleGetDataByIdentificationUser = (arrayquestions) => {

        //console.log(user)

        findQuestionsByUser({
            state: 1
        }).payload.then(
            response => {

                (response.data.length === 0) ? getDataQuestions(arrayquestions) : convertDataQuestions(response.data, arrayquestions)

            }
        ).catch(
            error => {
                //console.log(error)
                handleOpenSnack("Ha ocurrido un error al obtener las preguntas registradas del cliente. Por favor vuelva a intentar.", "error")
                setLoading(false)
            }
        )
    }

    const convertDataQuestions = (data, arrayallquestions) => {

        try {

            setType("password")
            let arrayQuestions = []

            const responseNumberQuestionParameters = parameters.filter((item) => item.name === "NUMBER_QUESTION_SECURITY")

            const numberQuestionParameters = (responseNumberQuestionParameters.length > 0) ? parseInt(responseNumberQuestionParameters[0].value) : 5

            const numberQuestion = (numberQuestionParameters > arrayallquestions.length) ? 5 : numberQuestionParameters

            const numberQuestionfinal = (numberQuestion < data.length) ? numberQuestion : data.length

            setQuestion(data[0].question)
            setAnswer("")
            setFlagHaveQuestionsUser(true)

            for (let i = 0; i < numberQuestionfinal; i++) {
                let objectSave = {
                    title: "Pregunta " + (i + 1),
                    question: data[i].question,
                    answer: "",
                    id: data[i].id
                }

                getPositionQuestionById(arrayallquestions, data[i].question, 0)

                arrayQuestions.push(objectSave)
            }

            if (numberQuestion > data.length) {

                for (let i = 0; i < numberQuestion - data.length; i++) {
                    let objectSave = {
                        title: "Pregunta " + (data.length + i + 1),
                        question: 0,
                        answer: "",
                        id: 0
                    }

                    arrayQuestions.push(objectSave)
                }

            }

            setDataQuestionsSelected(arrayQuestions)
            setLoading(false)
        } catch (error) {
            // const responsePhoneNumber = parameters.filter((item) => item.code === "PHONE_NUMBER_CALL_CENTER")
            // console.log(responsePhoneNumber)
            handleOpenSnack("Ha ocurrido un error al obtener las preguntas registradas. Por favor llamar a servicio al cliente.", "error")
        }

    }

    const getDataQuestions = (arrayquestions) => {

        setType("text")

        const responseNumberQuestionParameters = parameters.filter((item) => item.name === "NUMBER_QUESTION_SECURITY")

        const numberQuestionParameters = (responseNumberQuestionParameters.length > 0) ? responseNumberQuestionParameters[0].value : 5

        const numberQuestion = (numberQuestionParameters > arrayquestions.length) ? 5 : numberQuestionParameters

        let arrayQuestions = []

        for (let i = 0; i < numberQuestion; i++) {
            let objectSave = {
                title: "Pregunta " + (i + 1),
                question: 0,
                answer: "",
                id: i
            }

            arrayQuestions.push(objectSave)
        }

        setDataQuestionsSelected(arrayQuestions)
        setLoading(false)
    }

    const handleSubmit = async (values) => {
        //console.log(values)
        setLoading(true)

        const responseNumberQuestionParameters = parameters.filter((item) => item.name === "NUMBER_QUESTION_SECURITY")

        const numberQuestionParameters = (responseNumberQuestionParameters.length > 0) ? parseInt(responseNumberQuestionParameters[0].value) : 5

        const numberQuestion = (numberQuestionParameters > dataQuestions.length) ? 5 : numberQuestionParameters

        if (question !== 0) {

            const responseSearchQuestions = (question !== dataQuestionsSelected[activeStep].question) ? dataQuestionsSelected.filter(item => item.question === question) : []

            if (responseSearchQuestions.length === 0) {
                if (question !== dataQuestionsSelected[activeStep].question) {
                    getPositionQuestionById(dataQuestions, dataQuestionsSelected[activeStep].question, 1)
                    getPositionQuestionById(dataQuestions, question, 0)
                }
                const dataQuestionsSelectedAux = dataQuestionsSelected;
                dataQuestionsSelected[activeStep].question = question;
                dataQuestionsSelected[activeStep].answer = answer.toUpperCase();
                setDataQuestionsSelected(dataQuestionsSelectedAux)

                if (activeStep < (parseInt(numberQuestion) - 1)) {
                    if (dataQuestionsSelected[activeStep + 1].answer.length > 0) {
                        setAnswer(dataQuestionsSelected[activeStep + 1].answer)
                        setQuestion(dataQuestionsSelected[activeStep + 1].question)
                    } else {
                        setAnswer("")
                        setQuestion(0)
                    }
                }
                setActiveStep(activeStep + 1)
            } else {
                handleOpenSnack("La pregunta ya ha sido seleccionada. Por favor seleccione una pregunta diferente.", "info")
            }

            //console.log("ActiveStep: ", activeStep)

            if ((activeStep >= (parseInt(numberQuestion) - 1)) && (responseSearchQuestions.length === 0)) {
                //console.log(user)
                //console.log(dataQuestionsSelected)
                const { ip } = devices
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                handleGenerateOtp(ipSend)
            } else {
                setLoading(false)
            }
        } else {
            setLoading(false)
            handleOpenSnack("Debe seleccionar una pregunta.", "info")
        }

    }

    const handleCompareCodeOtp = async (valuesFormOtp) => {

        try {

            setLoading(true)
            setOpenDialogOTP(false)

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 24,
                inputOtp: valuesFormOtp.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            const sendDataQuestions = dataQuestionsSelected.map((item) => {
                return {
                    ...item,
                    answer: encrypt(item.answer)
                }
            })

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                createQuestionsByUser({
                    action: (flagHaveQuestionsUser === false) ? encrypt("create") : encrypt("update"),
                    questions: sendDataQuestions,
                    device: encrypt(JSON.stringify({
                        os: device,
                        ip,
                        mac,
                        type: 24
                    })),
                    otp: encrypt(valuesFormOtp.data)
                }).payload.then(
                    response => {

                        //console.log(response)

                        const { message, type, error } = response

                        handleOpenSnack(message, type)

                        setLoading(false)

                        if (error === false) {

                            props.responseQuestion(0)
                            if (user.flagResetPassword === 1) {
                                history.push("/password-change")
                            } else {
                                history.push("/")
                            }

                        }

                    }
                ).catch(
                    error => {
                        //console.log(error)
                        handleOpenSnack("Ha ocurrido un error al obtener las preguntas. Por favor vuelva a intentar.", "error")
                        setLoading(false)
                    }
                )
            } else {
                if (viewDialogOtp === false) {
                    setOpenDialogOTP(false)
                } else {
                    setOpenDialogOTP(true)
                }
                setLoading(false)
                handleOpenSnack(message, type);
            }
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener las preguntas. Por favor vuelva a intentar.", "error")
        }

    }

    const handleGenerateOtp = () => {

        try {

            setLoading(true)

            const { ip, device, mac } = devices;

            const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type: 24, deviceData: device, ip, mac, action: 'questions' }))
            feathersCreateData('codes-recovery', { sendData })()
                .then((res) => {

                    setOpenDialogOTP(true)
                    setInitialTime(Date.now())

                    setLoading(false)
                }).catch(err => {
                    //console.log(err)
                    setLoading(false)
                    handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
                })

        } catch (error) {
            setLoading(false)
            handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
        }
    }

    const getPositionQuestionById = (arrayquestions, id, state) => {

        let dataQuestionsAux = arrayquestions

        //console.log(arrayquestions)

        for (let i = 0; i < arrayquestions.length; i++) {
            if (arrayquestions[i].id === id) {
                dataQuestionsAux[i].state = state;
            }
        }

        setDataQuestions(dataQuestionsAux)
    }

    const handleChangeQuestion = (data) => {

        if (data !== 0) {
            const dataFilterQuestion = (data !== dataQuestionsSelected[activeStep].question) ? dataQuestionsSelected.filter(item => item.question === data) : [];

            if (dataFilterQuestion.length === 0) {
                setQuestion(data)
            } else {
                handleOpenSnack("La pregunta ya ha sido seleccionada. Por favor seleccione una pregunta diferente.", "info")
            }
        } else {
            handleOpenSnack("Debe seleccionar una pregunta.", "info")
        }

    }

    const handleChangeAnswer = (value) => {
        //console.log(value)
        const error = formValidation("text", 1, 50, value) || ""
        setFormErrors({
            answer: error
        })
        setAnswer(value)
    }

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false)
        //this.setState({ openDialogOTP: false })
    };

    const handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6
        if (valueinput.target.value.toString().length === tokenLength) {
            // console.log("VALUE OTP: ", valueinput)
            handleCompareCodeOtp({ data: valueinput.target.value.toString() });
        }

    }

    const handleBackQuestions = () => {
        //console.log("Respuesta anterior: ", dataQuestionsSelected[activeStep - 1].answer)
        setQuestion(dataQuestionsSelected[activeStep - 1].question)
        setAnswer(dataQuestionsSelected[activeStep - 1].answer)
        setActiveStep(activeStep - 1)
    }

    const renderBody = () => {

        const timeLifeTokenObj = filterArrayEqual(parameters, 'code', 'TIME_LIFE_TOKEN')
        const timeLifeToken = (timeLifeTokenObj.length > 0) ? Number(timeLifeTokenObj[0].value) : 180000

        return <div style={{
            padding: "20px",
            border: '2px solid #BEBCC0',

            borderRadius: "8px",
            // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
        }}>
            <Grid container spacing={3}>
                <Grid xs={12} >
                    <Title><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Preguntas de Seguridad</Title>
                </Grid>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <StepperQuestions
                        activeStep={activeStep}
                        steps={dataQuestionsSelected}
                        orientation={"vertical"}
                        handleNext={handleSubmit}
                        question={question}
                        dataquestions={dataQuestions}
                        handleChangeQuestion={handleChangeQuestion}
                        handleChangeAnswer={handleChangeAnswer}
                        answer={answer}
                        handleBack={handleBackQuestions}
                        formErrors={formErrors}
                        type={type}
                        setType={setType}
                    />
                </Grid>
            </Grid>
            <DialogOTP
                openDialogOTP={openDialogOTP}
                loading={loading}
                initialTime={initialTime}
                showQR={false}
                onCloseDialogOTP={handleCloseDialogOTP}
                onKeyPress={handleChangeInputOtp}
                OTPSubmit={handleCompareCodeOtp}
                timeLifeToken={timeLifeToken}
                refreshToken={handleGenerateOtp}
            />
        </div>
    }

    return (
        <div>
            <Dashboard
                title=""
                body={renderBody()}
                multiple={false}
            />
            <Footer />
            <LoadingScreen open={loading} />

        </div>
    );

}

export default connect(null, { QuestionsContainer, createQuestionsByUser, responseQuestion, findQuestionsByUser, sendLogs, changeStatusUser, sendEmail })(QuestionsContainer);